import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@weezevent/nacre';
import Styles from '../../styles/templates/template.module.css';

export const ImageBackground = React.memo(({ className = '', previewUrl }) => {
    return <div className={`${Styles['image-container']} ${className}`} style={{ backgroundImage: `url(${window.weezConfig.yuga}/${previewUrl})` }} />;
});

ImageBackground.propTypes = {
    previewUrl: PropTypes.string
};

export const TemplateItem = React.memo(({ template, onSelect, selectedTemplate }) => {
    return (
        <div
            className={onSelect ? (selectedTemplate === template.id ? Styles['selected-template-card'] : Styles['template-card']) : Styles['active-template-card']}
            onClick={onSelect}
        >
            <ImageBackground previewUrl={template.preview_url} />
            <div className={Styles['content']}>{template.name}</div>
            <div className={selectedTemplate === template.id ? Styles['check-icon-selected'] : Styles['check-icon']}>
                <Icon name="check" />
            </div>
        </div>
    );
});

TemplateItem.propTypes = {
    onSelect: PropTypes.func,
    template: PropTypes.object,
    selectedTemplate: PropTypes.number
};
